module.exports = __webpack_public_path__ + "static/media/news_p1_3.d9aee14e.png";